import { render, staticRenderFns } from "./marketPlace.vue?vue&type=template&id=65e5b0d0&scoped=true"
import script from "./marketPlace.vue?vue&type=script&lang=js"
export * from "./marketPlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e5b0d0",
  null
  
)

export default component.exports